<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="scaleForm" class="col-12">
            <!-- Hidden Inputs for ID -->
            <input matInput [formControlName]="'id'" hidden>
            <input matInput [formControlName]="'invoiceId'" hidden>
            <mat-checkbox [formControlName]="'isEmployeeShare'" style="display: none;"></mat-checkbox>

            <div class="row p-0">
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Charge</mat-label>
                        <mat-select formControlName="chargeId" required>
                            <mat-option *ngFor="let item of charge" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Amount</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Negative and decimal values are allowed."
                            [formControlName]="'amount'" pattern="^-?[0-9]+(\.[0-9]*)?$">
                    </mat-form-field>
                </div>
            </div>
            <div class="row p-0" *ngIf="!scaleForm.get('isEmployeeShare')?.value">
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Employee Share</mat-label>
                        <input matInput placeholder="Enter Employee Share" type="text"
                            matTooltip="Enter a valid amount. Negative and decimal values are allowed."
                            [formControlName]="'employeeShare'" pattern="^-?[0-9]+(\.[0-9]*)?$">
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="btn btn-success yes-button" [disabled]="scaleForm.invalid" (click)="save()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{data.confirmText}}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>